<template>
  <div class="hero-container overflow-y-auto">
    <v-container>
      <v-row class="text-center">
        <v-col class="mb-4">
          <h1 class="text-shadow-1 hero-header">
            Michael <br class="mobile-only" />McFarland
          </h1>

          <div class="hero-subhead">
            <div class="design-left">
              <h3 class="text-shadow-1">I design and create&nbsp;</h3>
            </div>
            <div class="type-right">
              <vue-typer
                :text="[
                  'Websites ',
                  'Mobile Apps ',
                  'Interactive UI ',
                  'Software Solutions ',
                ]"
                :repeat="Infinity"
                :shuffle="false"
                initial-action="typing"
                :pre-type-delay="43"
                :type-delay="100"
                :pre-erase-delay="1400"
                :erase-delay="70"
                erase-style="backspace"
                :erase-on-complete="false"
                caret-animation="blink"
              >
              </vue-typer>
            </div>
          </div>

          <v-btn
            href="#contact"
            class="mcf-blue-btn"
            dark
            x-large
            elevation="3"
          >
            GET IN TOUCH
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";

export default {
  components: {
    VueTyper,
  },
};
</script>

<style lang="scss">
@import "../scss/styles.scss";

.hero-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/images/delarch2-min.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 44%;
  background-attachment: fixed;
  z-index: 1;
  box-shadow: 0 6px 5px 0 rgb(0 0 0 / 60%);
  @include md {
    background-position: 50%;
  }
  h1 {
    font-family: "Montserrat", sans-serif;
    font-weight: 900;
    color: $white;
    font-size: 3.2rem;
    @include md {
      font-size: 4.5rem;
    }
  }
  h3 {
    font-size: 2.2rem;
    display: block;
    font-weight: 400;
    color: $mcf-grey;
  }
  .hero-header {
    line-height: 1.2;
    margin: 1rem 0 2rem;
    @include sm {
      margin: 0.2rem 0;
    }
  }

  .vue-typer {
    font-size: 2.2rem;
    display: block;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    span {
      color: $mcf-blue;
      text-shadow: #000 0 2px 4px;
    }
  }
  // both columns
  .design-left,
  .type-right {
    @include sm {
      display: inline-block;
      width: 50%;
    }
  }
  // first column - I design and create
  .design-left {
    @include sm {
      text-align: right;
    }
  }
  // second column - all the wonderful things I do list
  .type-right {
    .vue-typer {
      @include sm {
        text-align: left;
      }
    }
  }
  .caret {
    background-color: $mcf-grey;
    font-size: 1.8rem;
  }
  .mcf-blue-btn {
    background-color: $mcf-blue !important;
    font-weight: 700;
    margin: 2rem 0;
    span {
      font-size: 1.4rem;
    }
  }
}
</style>